import { Namespace, type TFn } from "@racoon/i18n";

/** The Nth occurrence of a weekday in the month: week 5 is the 29th-31st. */
export const WEEKS_OF_MONTH = [1, 2, 3, 4, 5] as const;

/** Reads a rule's day-of-month mask back into weeks; null for "*" (every week). */
export const dayOfMonthMaskToWeeks = (mask: string | undefined): number[] | null => {
  if (!mask || mask === "*") return null;
  const days = new Set<number>();
  mask.split(",").forEach((part) => {
    const [from, to = from] = part.split("-").map(Number);
    for (let day = from; day <= to; day++) days.add(day);
  });
  // A week counts when the mask covers its first day.
  return WEEKS_OF_MONTH.filter((week) => days.has(week * 7 - 6));
};

/** "Weeks of the month: 1, 3" for a rule limited to some weeks. */
export const weeksOfMonthLabel = (t: TFn, weeks: number[]): string =>
  t(Namespace.PickupLocation, "schedule.weeksOfMonthLabel", {
    weeks: [...weeks].sort((a, b) => a - b).join(", "),
  });
